import React, { createContext, useContext, useRef, useEffect, ReactNode } from 'react';

interface AnimationContextType {
  getAnimationTime: () => number;
}

const AnimationContext = createContext<AnimationContextType | undefined>(undefined);

export const AnimationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const startTimeRef = useRef<number>(Date.now());
  
  const getAnimationTime = () => {
    return Date.now() - startTimeRef.current;
  };

  return (
    <AnimationContext.Provider value={{ getAnimationTime }}>
      {children}
    </AnimationContext.Provider>
  );
};

export const useAnimation = () => {
  const context = useContext(AnimationContext);
  if (context === undefined) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};